<template>
  <acv-banner
    variant="error"
    class="offline-alert"
  >
    You are currently offline.
  </acv-banner>
</template>

<script>
export default {
  name: 'AcvOfflineAlert',
  components: {
    AcvBanner: () => import('@acv/shared-vuejs').then((shared) => shared.AcvBanner),
  },
};
</script>

<style lang="scss" scoped>
.offline-alert {
  @apply tw-fixed
    tw-top-0;

  padding: 0.75rem 1.5rem;
  z-index: 999999999;
}
</style>
